(function () {
    'use strict';

    angular
        .module('app')
        .directive('searchPop', searchPop);

    searchPop.$inject = ['$window'];

    function searchPop($window) {
        // Usage:
        //     <searchPop></searchPop>
        // Creates:
        // 
        var directive = {
            bindToController: true,
            controller: ['$scope', '$http', controller],
            controllerAs: '$searchPop',
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope, element, attrs) {
            $(document).ready(function () {
                function resetSearchWindow(obj) {
                    $("#searchSuggestions").removeClass("hide");
                    $(".search-window").toggleClass("hide");
                    obj.toggleClass("open");
                    $(".search-icon").click(function () {
                        obj.toggleClass("open");
                    });
                    $("#headerSearch").val('');
                    $("#headerSearch").focus();    
                }

                //Desktop
                $("span.search-toggle").click(function (e) {
                    e.stopPropagation();
                    if ($(".nav-default").hasClass("expanded")) {
                        $(".nav-default").removeClass("expanded");
                        resetSearchWindow($(this));
                    } else {
                        resetSearchWindow($(this));
                    }
                });

                //do nothing when clicked inside search window
                $(".search-window").click(function(e) {
                    e.stopPropagation();
                });
                //hide search-window when user clicks outside of the search window
                $(document).click(function(e) {                    
                    //console.log("clicked outside of search window");
                    if (!$(".search-window").hasClass("hide")) {
                       resetSearchWindow($("span.search-toggle")); 
                    }                    
                });

                //Mobile
                $("li.search-icon-m").click(function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();

                    console.log("clicked");
                    $(".search-modal-m").addClass("open-filter");
                });

                $(".close-search-m").click(function (e) {
                    $(".search-modal-m").removeClass("open-filter");
                });
            });

			$("#headerSearch").autocomplete({
				highlight: true,
                source: function (request, response) {
                    $.ajax({
                        url: "/api/emr/search/autocomplete",
                        dataType: "json",
                        type: 'Get',
                        data: {
                            term: request.term,
                            size: window.headerSearchAutocompSize
                        },
                        success: function (data) {

                            response($.map(data.Data,
                                function (item) {
                                    return {
                                        label: item,
                                        value: item
                                    };
                                }));
                        }
                    });
				},
                select: function (event, ui) {
					$(this).val(ui.item.value);
	                $(this).trigger('input'); // Use for Chrome/Firefox/Edge
	                $(this).trigger('change');
	                $(this).closest('form').submit();
                },
                minLength: 2
            });

			$("#headerSearchMobile").autocomplete({
				highlight: true,
                source: function (request, response) {
                    $.ajax({
                        url: "/api/emr/search/autocomplete",
                        dataType: "json",
                        type: 'Get',
                        data: {
                            term: request.term,
                            size: window.headerSearchAutocompSize
                        },
                        success: function (data) {

                            response($.map(data.Data,
                                function (item) {
                                    return {
                                        label: item,
                                        value: item
                                    };
                                }));
                        }
                    });
				},
                select: function (event, ui) {
	                $(this).val(ui.item.value);
	                $(this).trigger('input'); // Use for Chrome/Firefox/Edge
	                $(this).trigger('change');
	                $(this).closest('form').submit();
                },
                minLength: 2
            });
        }

        function controller($scope, $http) {
            var $ctrl = this;

            $ctrl.text = "";

            $ctrl.search = function (e, q, searchUrl) {
                if (e) {
                    e.preventDefault();
                }

                $window.location.href = searchUrl + "?queryString=" + encodeURIComponent(q);
            }
        }
    }
})();



//////////////////
// WEBPACK FOOTER
// ./Views/Shared/Partials/SiteHeader/_searchPop.js
// module id = 32
// module chunks = 0